<template>
  <div>
    <b-row v-if="loading">
      <b-col md="6">
        <atom-spinner
          :animation-duration="1000"
          :size="60"
          color="#ff1d5e"
          class="float-right my-4"
        />
      </b-col>
    </b-row>
  <div class="animated fadeIn">
    <loader v-if="loading"></loader>
    <div v-if="!loading">
      <component-header
        title="Templates"
        :isLoading="isloading"
        @reload-data="reloadData"
        @create-press="$router.push({ path: 'notification-template/create' })"
        :hasback="false"
        :hasOption="true"
        :isCreate="false"
        @search-query="(val) => (filter = val)"
      />
      <b-card class="card-wrap" border-variant="info">
        <div>
          <b-table
            style="border-radius: 12px"
            :dark="false"
            :hover="true"
            :striped="false"
            :bordered="true"
            :small="false"
            :fixed="false"
            responsive
            :items="templateList"
            :fields="templateColumns"
            :current-page="currentPage"
            :per-page="perPage"
            thead-class="header"
            :filter="filter"
            class="mt-3 tableRadius"
            show-empty
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <template slot-scope="data" slot="SlNo">
              {{ data.index + 1 }}
            </template>
            <template slot-scope="data" slot="body">
              {{ showBody(data.item) }}
            </template>
            <template slot-scope="data" slot="action">
              <div class="inline_btnTable">
                <!-- <b-button
                  v-if="data.item"
                  @click="editRule(data.item)"
                  size="sm"
                  class="mr-2 my-0 main-navigation-button"
                  variant="primary"
                >
                  <i class="fas fa-pencil-alt"></i>
                </b-button> -->

                <b-button
                  v-if="data.item"
                  @click="deleteRule(data.item)"
                  size="sm"
                  class="mr-2 butto-circle delete"
                  variant="danger"
                >
                  <i class="fas fa-trash-alt"></i>
                </b-button>
              </div>
            </template>
            <template slot="empty">
              <div v-if="isloading" class="text-center">
                <span><b>Loading...</b></span>
              </div>
              <div v-else class="text-center">No data available.</div>
            </template>
          </b-table>
        </div>
        <div class="float-right">
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="templateList.length"
            aria-controls="my-table"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          ></b-pagination>
        </div>
      </b-card>
    </div>
  </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";
import loader from "@/components/loader/nipigeloader.vue";
import { AtomSpinner } from "epic-spinners";
export default {
  name: "NotificationTemplateList",
  data() {
    return {
      filter: "",
      loading: false,
      isloading: false,
      currentPage: 1,
      perPage: 8,
      sortBy: "createdAt",
      sortDesc: true,
      templateColumns: [
        {
          key: "SlNo",
        },
        {
          key: "service",
          label: "Type",
          filter: true,
        },
        {
          key: "concern",
        },
        {
          key: "body",
        },
        {
          key: "action",
          thStyle: { width: "8%" },
        },
      ],
    };
  },
  components: {
    ebButton,
    ComponentHeader,
    AtomSpinner,
    loader,
  },
  computed: {
    ...mapGetters({
      getFetchTemplateList: "emailTemplate/GetFetchTemplateList",
    }),
    templateList() {
      // return this.getFetchTemplateList;
      return this.getFetchTemplateList.filter((el) => {
        return (el.service + el.concern + el.body)
          .toLowerCase()
          .includes(this.filter.toLowerCase());
      });
    },
  },
  methods: {
    editRule(data) {
      this.$router.push({
        name: "templateSetupEdit",
        params: {
          id: data._id,
        },
      });
    },
    showBody(data) {
      if (data.service == "WHATSAPP") {
        let bodyComponent = data.components?.find(
          (component) => component.type == "body"
        );
        let textBody = bodyComponent?.parameters?.map(
          (textBody) => textBody.text
        );
        return textBody?.join(", ");
      } else return data.body;
    },
    async reloadData() {
      this.isloading = true;
      await this.$store.dispatch("emailTemplate/fetchTemplateAction");
      this.isloading = false;
    },

    async deleteRule(data) {
      this.$swal({
        title: "Delete this Template?",
        text: "Are you sure? This will be Remove?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          this.isloading = true;
          this.$store
            .dispatch("emailTemplate/deleteTemplate", data._id)
            .then((result) => {
              this.$swal({
                type: "success",
                title: "Success",
                text: "Template Deleted Successfully!",
              });
              location.reload();
              this.$router.push("/notification-template");
              this.templateList();
              this.isloading = false;
            });
        }
      });
    },
  },

  async mounted() {
    this.loading = true;
    await this.$store.dispatch("emailTemplate/fetchTemplateAction");
    this.loading = false;
  },
};
</script>
<style scoped>
.edit {
  color: white !important;
}
.text-center {
  text-align: center;
}
.form-div label {
  margin-top: 8px;
}
.btn-danger {
  color: #fff;
  background-color: #f5222d;
  border-color: #f5222d;
  border-radius: 50px;
  height: 36px;
  width: 36px;
  text-align: center;
  line-height: 36px;
  padding: 0;
}
.mr-sm-4, .mx-sm-4 {
  margin-right: 2.25rem !important;
  margin-top: 2px;
}
</style>
